<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Reset Password</h4>
                                    <p>Please enter your new password.</p>
                                </div>
                                <vs-input
                                    ref="password"
                                    type="password"
                                    data-vv-validate-on="blur"
                                    v-validate="'required|min:6'"
                                    name="password"
                                    label-placeholder="Password"
                                    placeholder="Password"
                                    v-model="password"
                                    class="w-full" 
                                />
                                <span class="text-danger text-sm">{{ errors.first('password') }}</span>
                                <br>
                                <vs-input
                                    type="password"
                                    v-validate="'min:6|confirmed:password'"
                                    data-vv-validate-on="blur"
                                    data-vv-as="password"
                                    name="confirm_password"
                                    label-placeholder="Confirm Password"
                                    placeholder="Confirm Password"
                                    v-model="confirm_password"
                                    class="w-full" 
                                />
                                <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>
                                <br><br>
                                <!-- <vs-input type="password" label-placeholder="Password" v-model="value2" class="w-full mb-6" />
                                <vs-input type="password" label-placeholder="Confirm Password" v-model="value3" class="w-full mb-8" /> -->

                                <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
                                    <vs-button type="border" to="/login" class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">Go Back To Login</vs-button>
                                    <vs-button class="w-full sm:w-auto" :disabled="!validateForm" @click="resetPassword()">Reset</vs-button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            password: '',
            confirm_password: '',
        }
    },
     computed: {
        validateForm() {
            return !this.errors.any()  && this.password  && this.confirm_password ;
        }
    },
    methods: {
        checkLogin() {
          // If user is already logged in notify
          if(this.$store.state.auth.isUserLoggedIn()) {

            // Close animation if passed as payload
            this.$vs.loading.close()

            this.$vs.notify({
              title: 'Login Attempt',
              text: 'You are already logged in!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })

            return false
          }
          return true
        },
        resetPassword() {
            if (!this.validateForm || !this.checkLogin()) return
            
            const payload = {
                password: this.password,
                password_confirmation : this.confirm_password,
                hash: this.$route.params.hash,
                email: this.$route.params.email
            }
            this.$store.dispatch('auth/resetPassword', payload)
                .then(response => {
                    this.$vs.loading.close() 
                    if(response.data.success)
                    {
                        this.$vs.notify({
                                title: 'Success',
                                text: response.data.message,
                                iconPack: 'feather',
                                icon: 'icon-check_box',
                                color: 'success'
                        })
                    }
                    else {
                        this.$vs.loading.close() 
                        this.$vs.notify({
                                title: 'Error',
                                text: response.data.message,
                                iconPack: 'feather',
                                icon: 'icon-alert-circle',
                                color: 'danger'
                        })
                    }
                })
                .catch(error => {
                    this.$vs.loading.close()
                    this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                })

        },

    }
}
</script>